<ng-container>
  <header class="header">
    <div class="close-button" onclick="history.back()"></div>
    <h1>
      <img
        class="logo-image"
        src="/assets/wellnesscloud-management/images/logo.svg"
        width="194"
        height="20"
        alt="SokusaiManagement"
      />
    </h1>
  </header>
  <div class="container isBackgoround">
    <main class="main-contents">
      <div class="container_min">
        <img
          src="/assets/wellnesscloud-management/images/password-reset-send_main.svg"
          width="302"
          height="133"
          alt="SokusaiManagement"
        />
        <h1 class="login-title mb-10">送信完了</h1>
        <p class="login-catch">
          ご案内メールをお送りしました
        </p>

        <div class="mb-10">
          <p style="font-weight: 600; word-wrap: break-word">{{ email }}</p>
          <p>
            に再設定のご案内メールを送信しました。記載されているURLに72時間以内にアクセスし、再設定を完了してください。
          </p>
        </div>

        <div
          class="v-card"
          style="
            background-color: var(--color-100-bold);
            border-color: var(--color-100-bold);
            border-radius: 8px;
            padding: 16px;
          "
        >
          <div class="v-card__title text-caption">
            <div>
              <p class="text-subtitle-1 d-flex align-center login-note-title">
                <i
                  id="icon-question"
                  aria-hidden="true"
                  class="v-icon notranslate v-icon--left mdi mdi-help-circle theme--right"
                ></i>
                <span>メールが届かない場合</span>
              </p>
              <p class="login-note-text">
                dx-utility.comのドメインからメールが届きます。認証メールが届かない場合は、迷惑メールフォルダに入る設定となっていないかご確認ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</ng-container>
